import React, { FC, PropsWithChildren, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getActiveAccount } from "@containers/Account/store/selectors";
import { getAccount } from "@containers/Account/store/actions";
import { selectors as sharedSelectors } from "@shared/store";
import { checkIfAdmin } from "@shared/utils/ACL";

export const AccountOwnerGuard: FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch();
  const activeAccount = useSelector(getActiveAccount());
  const activeUser = useSelector(sharedSelectors.getUserDetails());

  useEffect(() => {
    dispatch(getAccount.request({ id: Number(activeAccount?.id) }));
  }, [activeAccount?.id, dispatch]);

  if (checkIfAdmin(activeUser!) || activeAccount?.user_id !== activeUser?.id) {
    // Hack for impersonation
    // return Null instead of redirect
    // otherwise redirects to the root page
    return null;
  }

  return <>{children}</>;
};

export default AccountOwnerGuard;
